import $ from 'jquery';
import lozad from 'lozad';

$(() => {
    // lazy loads elements with default selector as '.lozad'
    const observer = lozad('.lozad', {
        loaded(el) {
            el.classList.add('loaded');
        },
    });
    observer.observe();
});
